import type { RatingEnvironment } from './types'

/** Categorías que usan el sistema de valoraciones propio (BD) en la PDP; el
 * resto usa Bazaarvoice (spec.md FR-001/FR-002, research.md R1). Nicenames de
 * categoría de nivel superior, mismos valores que segmentan la URL pública
 * (`/entradas/{categoria}/...`) y que ya se usan como claves de categoría en
 * `Explora.constants.ts` (`CATEGORY_ICON_MAP`). */
export const OWN_RATING_CATEGORIES = ['conciertos', 'festivales', 'deporte'] as const

/** Umbral mínimo de valoraciones para mostrar puntuación, por entorno — regla
 * de negocio permanente, no un ajuste temporal (spec.md FR-017). Aplica por
 * igual al sistema propio (BD) y a Bazaarvoice (FR-009). */
export const RATING_THRESHOLDS: Readonly<Record<RatingEnvironment, number>> = {
  local: 1,
  development: 1,
  preproduction: 5,
  production: 5,
}

/** URL del script de Bazaarvoice por entorno (spec.md, contracts/bazaarvoice-integration.md). */
export const BAZAARVOICE_SCRIPT_URLS: Readonly<Record<RatingEnvironment, string>> = {
  local: 'https://apps.bazaarvoice.com/deployments/elcorteingles/entradas/staging/es_ES/bv.js',
  development: 'https://apps.bazaarvoice.com/deployments/elcorteingles/entradas/staging/es_ES/bv.js',
  preproduction: 'https://apps.bazaarvoice.com/deployments/elcorteingles/entradas/production/es_ES/bv.js',
  production: 'https://apps.bazaarvoice.com/deployments/elcorteingles/entradas/production/es_ES/bv.js',
}
